import { create } from "zustand";

/**
 * Transient flag: the sidebar is currently animating (collapse/expand) or
 * being drag-resized, i.e. the main viewport's width is changing every frame.
 * The calendar's %-based grid scales natively with the browser's own layout,
 * but the per-column px measurements (nest layout, content fit) must not chase
 * it — re-measuring per frame re-renders every mounted column 60×/s (visible
 * stutter). While active, DayColumn skips its RO measure and settles once when
 * the gesture ends (see DayColumn).
 */
interface SidebarAnimState {
  active: boolean;
  begin: () => void;
  end: () => void;
}

export const useSidebarAnimStore = create<SidebarAnimState>((set) => ({
  active: false,
  begin: () => set({ active: true }),
  end: () => set({ active: false }),
}));
